import {FC, useState} from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Button } from '@progress/kendo-react-buttons';
import { CommandType } from '../NexParkLocationsGrid';
import { BulkSetLotBillableStatusRequest, nexParkInstanceService, notifications } from '../../../../services';
import {Spinner} from "../../../../components/common";
import { BillingMode } from '../../../../model/api/customers/billing-mode';
import { nexResponseService } from '../../../../services/api/nexResponse';

interface IProps {
  customerId: number;
  billingMode: BillingMode;
  commandType: CommandType;
  selectedLotIds: number[];
  onClose: (result?: { selectedLotIds?: number[] }) => void;
}

const ChangeBillableDialog: FC<IProps> = ({ customerId, billingMode, commandType, selectedLotIds, onClose }) => {
  const selectedItemsCount = selectedLotIds.length
  const [busy, setBusy] = useState(false);

  const handleClose = () => {
    if (busy) {
      return;
    }
    onClose();
  };

  const handleConfirm = async () => {
    try {
      setBusy(true)
      const request: BulkSetLotBillableStatusRequest = {
        lotIds: selectedLotIds,
        isBillable: commandType === CommandType.SetBillable,
      };

      billingMode === BillingMode.NexResponse ?
        await nexResponseService.bulkSetLotBillableStatus(customerId, request) :
        await nexParkInstanceService.bulkSetLotBillableStatus(customerId, request);

      notifications.success(`Billable status for ${selectedLotIds.length} items has been updated.`);
      onClose({ selectedLotIds });
    } catch (error) {
      console.error('Error setting billable status:', error);
    } finally {
      setBusy(false)
    }
  };

  return (
    <Dialog title='Confirm Billable Change' onClose={handleClose} width={480}>
      <div>
        <p>
          You have chosen {selectedItemsCount} {selectedItemsCount === 1 ? 'item' : 'items'}.
        </p>
        <p>This will change the billable setting for the selected location(s)</p>
        <p>Do you wish to continue?</p>
      </div>
      {busy && (
          <div style={{ minHeight: 120, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Spinner />
          </div>
      )}
      <DialogActionsBar>
        <Button disabled={busy} onClick={handleClose}>Cancel</Button>
        <Button disabled={busy} themeColor={'primary'} onClick={handleConfirm}>
          Proceed
        </Button>
      </DialogActionsBar>
    </Dialog>
  );
};

export default ChangeBillableDialog;
